import React from 'react';
import I18n from 'i18n-js';
import staticRider from 'public/images/static-rider.svg';
import styles from './route-optimization-onboarding.less';

const RouteOptimizationOnboarding = () => (
  <div className={styles.routeOptimizationOnboarding}>
    <img className={styles.rider} src={staticRider} alt={'rider'} />
    <div className={styles.title}>
      {I18n.t('v2.locationDrawer.routeOptimizationOnboarding.title')}
    </div>
    <div className={styles.text}>
      {I18n.t('v2.locationDrawer.routeOptimizationOnboarding.text')}
    </div>
  </div>
);

export default RouteOptimizationOnboarding;
